import actions from "./actions";

export default {
  namespaced: true,
  state: {
    lastLessons: []
  },
  mutations: {
    setLastLessons(state, lastLessons) {
      state.lastLessons = lastLessons;
    }
  },
  actions
};
